import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Field } from 'redux-form';
import { makeStyles } from '@material-ui/core';
import Fields from 'components/Fields';
import { MetaType } from 'store/modules/Meta/types';
import { PolicyBox } from 'components/Base';
import Store from 'store/store';
import PolicyDetails from './PolicyDetails';
import { FundAllocationType } from 'store/modules/ExistingPolicies/types';

const { connect, selectors } = Store;

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexGrow: 1
  },
  field: {
    marginLeft: '1rem'
  }
});

interface PolicyProps {
  policy: string;
  policyTypes: MetaType;
  policyProviders: MetaType;
  policyPlatforms: MetaType;
  funds: Array<FundAllocationType>;
}

const Policy = ({
  policy,
  policyTypes,
  policyProviders,
  policyPlatforms,
  funds
}: PolicyProps) => {
  const classes = useStyles();

  return (
    <PolicyBox
      boxColor="#D95045"
      dropdownContent={<PolicyDetails funds={funds} />}
    >
      <div className={classes.container}>
        <Grid item xs={2} md={1} className={classes.field}>
          <Field
            name={`${policy}.owner.display_name`}
            fullWidth
            validate={Fields.Validators.required}
            component={Fields.String}
            disabled
            label="Policy Owner(s)"
            bolded
          />
        </Grid>

        <Grid item xs={2}>
          <Field
            name={`${policy}.platform`}
            fullWidth
            validate={Fields.Validators.required}
            displayEmpty
            options={policyPlatforms}
            component={Fields.String}
            label="Platform"
            bolded
          />
        </Grid>

        <Grid item xs={2}>
          <Field
            name={`${policy}.provider`}
            fullWidth
            validate={Fields.Validators.required}
            displayEmpty
            options={policyProviders}
            component={Fields.String}
            label="Policy Provider"
            bolded
          />
        </Grid>

        <Grid item xs={2}>
          <Field
            name={`${policy}.type`}
            fullWidth
            validate={Fields.Validators.required}
            displayEmpty
            options={policyTypes}
            component={Fields.String}
            label="Policy Type"
            bolded
          />
        </Grid>

        <Grid item xs={2}>
          <Field
            name={`${policy}.number`}
            fullWidth
            validate={Fields.Validators.required}
            component={Fields.String}
            label="Policy Number"
            bolded
          />
        </Grid>
      </div>
    </PolicyBox>
  );
};

export default connect((state: any) => ({
  policyTypes: selectors.metaSelectors.policyTypes(state),
  policyProviders: selectors.metaSelectors.policyProviders(state),
  policyPlatforms: selectors.metaSelectors.policyPlatforms(state)
}))(Policy);
